import { render, staticRenderFns } from "./backgroundAnimation.vue?vue&type=template&id=cb2d373c&scoped=true"
import script from "./backgroundAnimation.vue?vue&type=script&lang=js"
export * from "./backgroundAnimation.vue?vue&type=script&lang=js"
import style0 from "./backgroundAnimation.vue?vue&type=style&index=0&id=cb2d373c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb2d373c",
  null
  
)

export default component.exports